var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-abstract-title"},[_c('p',{staticClass:"data-abstract-title-item left"},[_vm._v(_vm._s(_vm.title1))]),_c('p',{staticClass:"data-abstract-title-item middle"},[_vm._v(_vm._s(_vm.title2))]),_c('p',{staticClass:"data-abstract-title-item right"},[_vm._v(_vm._s(_vm.title3))])])
}
var staticRenderFns = []

export { render, staticRenderFns }